import { IPageFlowStep } from "../Interfaces/page-flow";

export const getFlowSteps = (startFlow: IPageFlowStep) => {
  const steps: IPageFlowStep[] = [];
  steps.push(startFlow);

  if (startFlow.childFlowSteps) {
    startFlow.childFlowSteps
      .map((flowStep) => getFlowSteps(flowStep))
      .forEach((stepFlows) => {
        if (stepFlows) {
          stepFlows.forEach((flowStep) => {
            if (flowStep) {
              if (!steps.find((step) => step.name === flowStep.name)) {
                steps.push(flowStep);
              }
            }
          });
        }
      });
  }
  return [...steps];
};
